import React from "react"
import {
  View,
  Text,
  Window,
  Grid,
  Col,
  Icon,
  TextLink,
  Chip,
  Radio,
  Checkbox,
} from "react-ame-components"

export class TextExample extends React.Component {
  state = {
    example: "Carregando..",
    checkState: false,
  }

  timeout = null

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({ example: "Exemplo vindo do state" })
    }, 1000)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <Grid>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
            <Col columnSize={{ sm: 10, md: 6 }}>
              <View
                backgroundColor="neutral-100"
                padding="big"
                borderRadius="small"
                shadow="level-2"
                direction="column"
                align="center">
                <Text
                  fontSize="large"
                  lineHeight="large"
                  fontWeight="bold">
                  Componente [color=primary]Text[/color]
                </Text>
                <View marginVertical="extra-small">
                  <View
                    flexWrap="wrap"
                    padding="nano"
                    backgroundColor="none">
                    <Text
                      fontSize="medium"
                      fontWeight="bold">
                      Exemplo de componente de [color=primary]texto[/color]
                    </Text>
                  </View>

                  <View
                    flexWrap="wrap"
                    padding="nano"
                    backgroundColor="none">
                    <Text
                      fontSize="large"
                      fontWeight="bold">
                      Texto contendo um icone:{" "}
                      <Icon
                        icon="ame-outline"
                        colorIcon="neutral-900"
                      />
                    </Text>
                  </View>
                  <View
                    flexWrap="wrap"
                    padding="nano"
                    backgroundColor="none">
                    <Text
                      fontSize="extra-small"
                      fontWeight="bold">
                      Texto contendo um textLink:{" "}
                      <TextLink onPress={() => alert("TextLink")}>
                        Clique aqui!
                      </TextLink>
                    </Text>
                  </View>
                  <View
                    flexWrap="wrap"
                    padding="nano"
                    backgroundColor="none">
                    <Text
                      fontSize="extra-small"
                      fontWeight="bold">
                      Texto contendo um Chip: <Chip label="Categoria" />
                    </Text>
                  </View>
                  <View
                    flexWrap="wrap"
                    padding="nano"
                    backgroundColor="none">
                    <Text
                      fontSize="extra-small
                    ">
                      Exemplo BBCode com texto vindo de um state:
                      [color=primary][b][i]{this.state.example}[/i][/b][/color]
                    </Text>
                  </View>
                  <View
                    flexWrap="wrap"
                    padding="nano"
                    backgroundColor="none">
                    <Text
                      fontSize="extra-small"
                      fontWeight="bold">
                      <Radio
                        name="radioText"
                        checked={false}
                      />{" "}
                      Opção com Radio.
                    </Text>
                  </View>
                  <View
                    flexWrap="wrap"
                    padding="nano"
                    backgroundColor="none">
                    <Text
                      fontSize="extra-small"
                      fontWeight="bold">
                      <Checkbox
                        value="check"
                        checked={this.state.checkState}
                        onChange={e => this.setState({ checkState: e.checked })}
                      />{" "}
                      Opção com Checkbox.
                    </Text>
                  </View>
                </View>
              </View>
            </Col>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
          </Grid>
        </View>
      </Window>
    )
  }
}
